import React from "react";
import { Route } from "react-router-dom";
import { CustomersLoadingDialog } from "./customers-loading-dialog/CustomersLoadingDialog";
import { CustomerEditDialog } from "./customer-edit-dialog/CustomerEditDialog";
import { CustomerDeleteDialog } from "./customer-delete-dialog/CustomerDeleteDialog";
// import { CustomersDeleteDialog } from "./customers-delete-dialog/CustomersDeleteDialog";
import { CustomersFetchDialog } from "./customers-fetch-dialog/CustomersFetchDialog";
import { CustomersUpdateStateDialog } from "./customers-update-status-dialog/CustomersUpdateStateDialog";
import { CustomersUIProvider } from "./CustomersUIContext";
import { CustomersCard } from "./CustomersCard";
import AddVehicle from '../../../../pages/Vehicle/Form/AddVehicle'
export function CustomersPage({ history }) {
  const customersUIEvents = {
    newCustomerButtonClick: () => {
      history.push("/vehicle/addvehicle/new");
    },
    openEditCustomerDialog: (id) => {
      history.push(`/vehicle/addvehicle/${id}/edit`);
    },
    openDeleteCustomerDialog: (id) => {
      history.push(`/vehicle/addvehicle/${id}/delete`);
    },
    openDeleteCustomersDialog: () => {
      history.push(`/vehicle/addvehicle/deleteCustomers`);
    },
    openFetchCustomersDialog: () => {
      history.push(`/vehicle/addvehicle/fetch`);
    },
    openUpdateCustomersStatusDialog: () => {
      history.push("/vehicle/addvehicle/updateStatus");
    }
  }

  return (
    <CustomersUIProvider customersUIEvents={customersUIEvents}>
      <CustomersLoadingDialog />
      <Route path="/vehicle/addvehicle/new">
        {({ history, match }) => (
          <AddVehicle
            show={match != null}
            onHide={() => {
              history.push("/vehicle/addvehicle");
            }}
          />
        )}
      </Route>



      {/* <Route path="/vehicle/addvehicle/:id/edit">
        {({ history, match }) => (
          <CustomerEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/vehicle/addvehicle");
            }}
          />
        )}
      </Route> */}

      <Route path="/vehicle/addvehicle/:id/delete">
        {({ history, match }) => (
          <CustomerDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/vehicle/addvehicle");
            }}
          />
        )}
      </Route>
      <Route path="/vehicle/addvehicle/fetch">
        {({ history, match }) => (
          <CustomersFetchDialog
            show={match != null}
            onHide={() => {
              history.push("/vehicle/addvehicle");
            }}
          />
        )}
      </Route>
      <Route path="/vehicle/addvehicle/updateStatus">
        {({ history, match }) => (
          <CustomersUpdateStateDialog
            show={match != null}
            onHide={() => {
              history.push("/vehicle/addvehicle");
            }}
          />
        )}
      </Route>
      <CustomersCard />
    </CustomersUIProvider>
  );
}
